// src/redux/productActions.js

import { fetchProductsFromFirestore, addProductToFirestore, deleteProductFromFirestore } from '../firebase/firebaseUtils';
import { fetchProductsStart, fetchProductsSuccess, fetchProductsFailure, addProduct, deleteProduct } from './productSlice';

// Fetch all products from Firestore
export const fetchProducts = () => async (dispatch) => {
  dispatch(fetchProductsStart());
  try {
    const products = await fetchProductsFromFirestore();
    dispatch(fetchProductsSuccess(products));
  } catch (error) {
    dispatch(fetchProductsFailure(error.message));
  }
};

// Add a new product
// In productActions.js, after adding the product:
export const addProductToStore = (productData) => async (dispatch) => {
  try {
    const newProduct = await addProductToFirestore(productData);
    dispatch(addProduct(newProduct));
  } catch (error) {
    dispatch(fetchProductsFailure(error.message));
    console.error('Error adding product:', error);
  }
};


// Delete a product
export const deleteProductFromStore = (productId) => async (dispatch) => {
  try {
    await deleteProductFromFirestore(productId);
    dispatch(deleteProduct(productId));
  } catch (error) {
    console.error('Error deleting product:', error);
  }
};
